'use strict';

exports.__esModule = true;

var _createSubscription = require('./createSubscription');

var _createSubscription2 = _interopRequireDefault(_createSubscription);

var _defineObservable = require('./defineObservable');

var _defineObservable2 = _interopRequireDefault(_defineObservable);

var _subscribeObserverAdapter = require('./subscribeObserverAdapter');

var _subscribeObserverAdapter2 = _interopRequireDefault(_subscribeObserverAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Generated by CoffeeScript 1.12.6
var combineLatest, defaultArrayProjection, defaultObjectProjection, none;

none = {};

defaultArrayProjection = function (x) {
  return x.slice();
};

defaultObjectProjection = function (x) {
  return Object.assign({}, x);
};

exports.default = combineLatest = function (observables, projection) {
  var count, isArray, k, subscribe;
  isArray = Array.isArray(observables);
  if (isArray) {
    count = observables.length;
  } else {
    count = 0;
    for (k in observables) {
      count++;
    }
  }
  if (typeof projection !== 'function') {
    projection = isArray ? defaultArrayProjection : defaultObjectProjection;
  }
  subscribe = (0, _subscribeObserverAdapter2.default)(function (observer) {
    var active, complete, emit, error, inactive, observable, sub, subscribeOne, subscriptions, unsubscribeAll, v, values;
    if (isArray) {
      values = function () {
        var i, len, results;
        results = [];
        for (i = 0, len = observables.length; i < len; i++) {
          observable = observables[i];
          results.push(none);
        }
        return results;
      }();
    } else {
      values = {};
      for (k in observables) {
        values[k] = none;
      }
    }
    active = count;
    inactive = count;
    subscriptions = [];
    unsubscribeAll = function () {
      var i, len, subscription;
      for (i = 0, len = subscriptions.length; i < len; i++) {
        subscription = subscriptions[i];
        if (typeof subscription.unsubscribe === "function") {
          subscription.unsubscribe();
        }
      }
    };
    error = function (err) {
      if (values == null) {
        return;
      }
      values = null;
      unsubscribeAll();
      return typeof observer.error === "function" ? observer.error(err) : void 0;
    };
    emit = function () {
      var err, result;
      try {
        result = projection(values);
      } catch (error1) {
        err = error1;
        error(err);
        return;
      }
      return typeof observer.next === "function" ? observer.next(result) : void 0;
    };
    complete = function () {
      if (values == null) {
        return;
      }
      if (--active === 0) {
        values = null;
        unsubscribeAll();
        return typeof observer.complete === "function" ? observer.complete() : void 0;
      }
    };
    subscribeOne = function (index, observable) {
      return subscriptions.push(observable.subscribe({
        next: function (x) {
          if (values == null) {
            return;
          }
          if (values[index] === none) {
            --inactive;
          }
          values[index] = x;
          if (inactive === 0) {
            return emit();
          }
        },
        complete: complete,
        error: error
      }));
    };
    if (isArray) {
      observables.forEach(function (observable, index) {
        return subscribeOne(index, observable);
      });
    } else {
      for (k in observables) {
        v = observables[k];
        subscribeOne(k, v);
      }
    }
    sub = (0, _createSubscription2.default)(observer, unsubscribeAll);
    if (typeof observer.start === "function") {
      observer.start(sub);
    }
    return sub;
  });
  return (0, _defineObservable2.default)({
    subscribe: subscribe
  });
};